import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ChangePassword } from '@app/auth/models';
import { ChangePasswordValidationMessages } from '@app/auth/models/change-password-validation-messages.model';
import { ChangePasswordService } from '@app/auth/services';

@Component({
    selector: 'ngx-change-password-form',
    templateUrl: './change-password-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ChangePasswordService],
    standalone: false
})
export class ChangePasswordFormComponent implements OnDestroy {
  form: UntypedFormGroup;
  validationMessages: ChangePasswordValidationMessages;

  @Input() loading = false;
  @Output() output = new EventEmitter<ChangePassword>();

  constructor(private service: ChangePasswordService) {
    this.validationMessages = this.service.validationMessages;
    this.form = this.service.form;
  }

  ngOnDestroy() {}

  save() {
    const formValue = this.service.save();

    if (formValue) {
      this.output.emit(formValue);
    }
  }
}
